import dayjs from 'dayjs'

import { usePostQuery } from './usePostQuery'

export const usePost = (id: string) => {
  const { postQuery } = usePostQuery([Number(id)], {
    refetchInterval: (data) => {
      // Video processing failed
      if (
        data?.statuses.resources === 'Processing' &&
        data?.type === 'Video' &&
        dayjs(data.updatedAt).isBefore(dayjs().subtract(1, 'hours'))
      ) {
        return false
      }

      return data?.statuses.resources === 'Processing' ? 2000 : false
    },
  })

  return {
    postQuery,
    post: postQuery.data || null,
  }
}
